export default __webpack_public_path__ + "static/work-smite-e97f494e3dfeddba1fae73babc85b4c3.jpg";